import { JavelinaBaseClient } from './JavelinaBaseClient'

export class JavelinaProxyClient extends JavelinaBaseClient {
    constructor(
        javelinaProxyApiUrl = process.env.JAVELINA_PROXY_API_URL, 
        javelinaProxySecretName = process.env.JAVELINA_PROXY_SECRET_NAME || '',
        axiosOptions
    ) {
        super(javelinaProxyApiUrl, javelinaProxySecretName, axiosOptions)
    }

    async get(path, params) {
        await this.createSecureAxiosInstance()

        const response = await this.secureAxiosInstance.get(path, {
            params: params
        });

        if (response.status !== 200) {
            return null;
        }

        return response.data;
    }
    
    async put(body, path) {
        await this.createSecureAxiosInstance()

        const response = await this.secureAxiosInstance.put(path, body);

        if (response.status !== 200) {
            return null;
        }

        return response.data;
    }
    
    async post(body, path) {
        await this.createSecureAxiosInstance()
        
        const response = await this.secureAxiosInstance.post(path, body);

        if (response.status !== 200) {
            return null;
        }

        return response.data;
    }
}
